import axios from 'axios';

const client = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL || '',
});

client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      localStorage.removeItem('@AtacDelivery:token');
      localStorage.removeItem('@AtacDelivery:user');

      window.location.reload();
    }

    return Promise.reject(error);
  },
);

export default client;
